/**
 * registry.js — every tutorial the app knows about.
 *
 * Add a tutorial by writing its definition folder and adding one line here.
 * Nothing else in the engine needs to change: the provider, the overlay and the
 * shield are all driven by whatever definition is running.
 */

import createBasics from './definitions/create-basics';

const registry = {
    [createBasics.id]: createBasics,
};

/** The tour offered when someone creates their first scenario. */
export const CREATE_BASICS = createBasics.id;

/**
 * The tutorials a user can start again whenever they like, for the menu that
 * offers them. `from` says which entry point a replay begins at, so a caller
 * only lists the ones it can actually launch.
 *
 * @param {string} [from] restrict to tutorials that start at this entry point
 */
export const replayableTutorials = (from) =>
    Object.values(registry).filter(
        (definition) => definition.replay && (from === undefined || definition.replay.from === from)
    );

export default registry;
